import { render } from "./Billing.vue?vue&type=template&id=6544d641"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
script.render = render

export default script